import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UsersService } from '../configuration/users/users.service';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class PrintDocumentService {
  
  // endpoints
  private _printDocEp = `${this._apiSvc.endpoints.monolith}/api/printoptions/printDocument`;

  constructor(
    private _apiSvc: ApiService,
    private _userSvc: UsersService
  ) { }

  /**
   * Search params
   * @param params 
   * @returns 
   */ 
  search(params: any): Observable<any> {

    const companyId = this._userSvc.getCompanyId();

    const coFilter = `CompanyId~eq~${companyId}`;

    const searchParams = {
      Filter: params.Filter ? `${params.Filter}~and~${coFilter}` : coFilter,
      sort: 'DocumentName-asc'
    };

    return this._apiSvc.search(this._printDocEp, searchParams);

  }

}
